/** Returns all ancestor paths for `path`, including `path` itself */
export const getPathAncestry = (path) => {
    if (!path)
        return [];
    const pathSnippets = path.split('/').filter((snippet) => snippet);
    const ancestry = pathSnippets.map((_, index) => {
        return `/${pathSnippets.slice(0, index + 1).join('/')}`;
    });
    // In ACW, the ancestry always includes a non-blank root, such as `console/`
    // However in Admin Apps, the root is always '/'. This ensures that the root
    // '/' is always present so Admin Apps get a complete and accurate ancestry
    return ['/', ...ancestry];
};
